<script setup lang="ts">
import Button from '~/components/UI/Button.vue'

// Pagina di errore Nuxt standard (renderizzata per qualunque createError()
// non gestito altrove, es. il 404 lanciato da pages/[...all].vue). Volutamente
// SENZA layout: un layout caricherebbe footer/brand-list/disclaimer ad ogni
// 404, e i 404 piu' frequenti sono proprio quelli generati da bot che
// scansionano percorsi di credenziali esposte - meglio restino il piu'
// leggeri possibile. Stesso contenuto di pages/not-found.vue (rimasta
// raggiungibile come URL diretto, ma non piu' usata internamente).
defineProps<{
  error: { statusCode: number, statusMessage?: string }
}>()

useHead({ title: 'Pagina non trovata — RisparmiaTu' })

// Ricaricamento completo della pagina, non una transizione SPA: l'errore è
// stato lanciato con fatal: true (vedi pages/[...all].vue), e nemmeno
// clearError({redirect}) - il meccanismo Nuxt dedicato proprio a uscire da
// una pagina di errore - si è dimostrato affidabile in pratica (verificato:
// la pagina di destinazione restava con contenuto centrale mancante pur con
// header/footer popolati). Per un pulsante su una pagina di errore, la
// solidità di un reload completo vale più della fluidità di una transizione
// SPA che in questo caso specifico non si riprende in modo pulito.
const goTo = (path: string) => {
  window.location.href = path
}
</script>

<template>
  <main class="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
    <div class="text-center">
      <div class="w-full flex place-content-center">
        <img src="/images/404.png" alt="Pagina non trovata" width="480" />
      </div>
      <p class="mt-6 text-xl leading-7 text-gray-600">
        Siamo bravissimi a trovare offerte ma sembra che questa
        pagina non esista.
      </p>
      <div class="mt-10 flex items-center justify-center gap-x-6">
        <Button @click="goTo('/')">
          Torna alla home
        </Button>
        <Button outlined @click="goTo('/contatti')">
          Contatta il supporto
          <span aria-hidden="true">&rarr;</span>
        </Button>
      </div>
    </div>
  </main>
</template>
